/* ---------------------------------------------------------------------------
   mp-cuenta-atras.js — Reloj de tarjetas de la promocion de envio gratis

   La barra de anuncios de Banzai es un bloque de TEXTO: no admite HTML ni
   Liquid, asi que no se puede montar un contador ni poner un icono desde el
   editor. La solucion es escribir el marcador [CUENTA] dentro del texto del
   anuncio; este script lo localiza y monta ahi el icono y las tarjetas.

   PARA CAMBIAR LA FECHA: las dos constantes FIN y TEXTO_ACCESIBLE, que tienen
   que decir lo mismo. La fecha va en hora de Madrid: +02:00 de finales de
   marzo a finales de octubre, +01:00 el resto del ano.

   Al terminar la promocion el anuncio entero se sustituye por FIN_TEXTO, en
   vez de dejar un contador a cero, que es peor que no tener nada. Aun asi,
   conviene editar el anuncio a mano desde el editor de temas.

   ACCESIBILIDAD: la barra de anuncios es un aria-live="polite", asi que un
   contador que cambia cada segundo se lo dictaria entero a un lector de
   pantalla una y otra vez. Las tarjetas y el icono van con aria-hidden y al
   lado se deja un texto equivalente, oculto a la vista, que no cambia nunca.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var FIN = new Date('2026-11-01T23:59:59+01:00');
  var MARCADOR = '[CUENTA]';
  var FIN_TEXTO = 'Envío gratis en pedidos desde 30 €';
  var TEXTO_ACCESIBLE = 'poco tiempo: la promoción acaba el 1 de noviembre';

  /* El mismo camion que usa snippets/mp-icon.liquid en las garantias de la
     ficha. Va copiado aqui porque un asset .js no puede renderizar Liquid, y
     el anuncio existe en paginas donde ese snippet no se pinta. Si alguna vez
     cambia el dibujo del icono, hay que tocarlo en los dos sitios.
     stroke="currentColor" hace que herede el crema del texto de la barra. */
  var ICONO_CAMION =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M2.8 7.4h10.4v8.3H2.8z"></path>' +
    '<path d="M13.2 10.2h3.5l2.9 2.9v2.6h-6.4z"></path>' +
    '<circle cx="6.6" cy="17.3" r="1.6"></circle>' +
    '<circle cx="16.4" cy="17.3" r="1.6"></circle>' +
    '</svg>';

  /* Dos digitos por grupo, que llegan hasta 99 dias. */
  var GRUPOS = [
    { clave: 'd', unidad: 'd' },
    { clave: 'h', unidad: 'h' },
    { clave: 'm', unidad: 'm' },
    { clave: 's', unidad: 's', extra: 'mp-cuenta__grupo--segundos' }
  ];

  function restante() {
    var ms = FIN - new Date();
    if (ms <= 0) return null;
    var s = Math.floor(ms / 1000);
    return {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
  }

  function dosDigitos(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function crearTarjeta() {
    var flip = document.createElement('span');
    flip.className = 'mp-flip';
    flip.innerHTML =
      '<span class="mp-flip__half mp-flip__half--top"><span></span></span>' +
      '<span class="mp-flip__half mp-flip__half--bottom"><span></span></span>' +
      '<span class="mp-flip__leaf mp-flip__leaf--top"><span></span></span>' +
      '<span class="mp-flip__leaf mp-flip__leaf--bottom"><span></span></span>';
    return flip;
  }

  /* Reparto de valores en la tarjeta durante el giro:
       mitad superior estatica -> valor NUEVO (queda tapada por la hoja)
       mitad inferior estatica -> valor VIEJO (queda tapada al final)
       hoja superior           -> valor VIEJO, es la que cae
       hoja inferior           -> valor NUEVO, es la que sube

     Los 640 ms del setTimeout son la suma de las dos animaciones (0,32 s de
     caida + 0,32 s de subida) de assets/mp-contador.css: es el momento en que
     la hoja inferior ya tapa la mitad estatica y se le puede cambiar el valor
     sin que se vea el salto. Si tocas esas duraciones, toca este numero. */
  function pintarTarjeta(flip, valor) {
    var anterior = flip.dataset.valor;
    if (anterior === valor) return;

    var t = flip.querySelector('.mp-flip__half--top > span');
    var b = flip.querySelector('.mp-flip__half--bottom > span');
    var lt = flip.querySelector('.mp-flip__leaf--top > span');
    var lb = flip.querySelector('.mp-flip__leaf--bottom > span');

    if (anterior === undefined) {
      t.textContent = valor;
      b.textContent = valor;
      lt.textContent = valor;
      lb.textContent = valor;
      flip.dataset.valor = valor;
      return;
    }

    t.textContent = valor;
    b.textContent = anterior;
    lt.textContent = anterior;
    lb.textContent = valor;

    flip.classList.remove('is-girando');
    void flip.offsetWidth; /* fuerza el reinicio de la animacion */
    flip.classList.add('is-girando');

    window.setTimeout(function () {
      b.textContent = valor;
    }, 640);

    flip.dataset.valor = valor;
  }

  function construir() {
    var caja = document.createElement('span');
    caja.className = 'mp-cuenta';
    caja.setAttribute('aria-hidden', 'true');

    GRUPOS.forEach(function (g) {
      var grupo = document.createElement('span');
      grupo.className = 'mp-cuenta__grupo' + (g.extra ? ' ' + g.extra : '');
      grupo.setAttribute('data-clave', g.clave);
      grupo.appendChild(crearTarjeta());
      grupo.appendChild(crearTarjeta());

      var u = document.createElement('span');
      u.className = 'mp-cuenta__unidad';
      u.textContent = g.unidad;
      grupo.appendChild(u);

      caja.appendChild(grupo);
    });

    return caja;
  }

  function refrescar(caja, queda) {
    GRUPOS.forEach(function (g) {
      var grupo = caja.querySelector('[data-clave="' + g.clave + '"]');
      if (!grupo) return;
      var texto = dosDigitos(queda[g.clave]);
      var tarjetas = grupo.querySelectorAll('.mp-flip');
      pintarTarjeta(tarjetas[0], texto.charAt(0));
      pintarTarjeta(tarjetas[1], texto.charAt(1));
    });
  }

  function iniciar() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    /* El marcador esta dentro de un nodo de texto suelto del anuncio. Se busca
       el elemento hoja que lo contiene para montar ahi el reloj. */
    var destino = null;
    var nodos = bar.querySelectorAll('*');
    for (var i = 0; i < nodos.length; i++) {
      if (!nodos[i].children.length && nodos[i].textContent.indexOf(MARCADOR) !== -1) {
        destino = nodos[i];
        break;
      }
    }
    if (!destino) return;

    var queda = restante();
    if (queda === null) {
      destino.textContent = FIN_TEXTO;
      return;
    }

    var partes = destino.textContent.split(MARCADOR);

    var icono = document.createElement('span');
    icono.className = 'mp-cuenta__icono';
    icono.setAttribute('aria-hidden', 'true');
    icono.innerHTML = ICONO_CAMION;

    var caja = construir();

    var oculto = document.createElement('span');
    oculto.className = 'mp-cuenta-oculto';
    oculto.textContent = TEXTO_ACCESIBLE;

    destino.textContent = '';
    destino.appendChild(icono);
    destino.appendChild(document.createTextNode(partes[0]));
    destino.appendChild(caja);
    destino.appendChild(oculto);
    if (partes[1]) destino.appendChild(document.createTextNode(partes[1]));

    refrescar(caja, queda);

    window.setInterval(function () {
      var q = restante();
      if (q === null) {
        destino.textContent = FIN_TEXTO;
        return;
      }
      refrescar(caja, q);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
